module.exports = __webpack_public_path__ + "static/img/retail3.6d23666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retail3.png
// module id = Oj8j
// module chunks = 2